import React, {useState} from 'react';
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import {FormGrid} from "../../../checkout/components/billingData/DataForm";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import {Modal, Paper} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {Delete, DeleteOutline, Edit} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import ArrayShifter from "../../../adminPages/ArrayShifter";

function AdminDropDownParam({param, onChange, onDelete}) {
    const [open, setOpen] = useState(false);
    const [newParam, setNewParam] = useState({});

    const onInputChange = (key, index, value) => {
        newParam.values[index][key] = value;
        setNewParam({...newParam});
    }

    const addItem = () => {
        newParam.values = newParam.values || [];
        newParam.values.push({label: '', price: 0, translation: false});
        setNewParam({...newParam});
    }

    const remove = (index) => {
        newParam.values = newParam.values || [];
        newParam.values.splice(index, 1);
        setNewParam({...newParam});
    }

    const handleOpen = () => {
        setNewParam(JSON.parse(JSON.stringify(param)));
        setOpen(true);
    }

    const submit = () => {
        onChange(newParam);
        setOpen(false);
    }

    const orderValues = (oldIndex, newIndex) => {
        const item = newParam.values.splice(oldIndex, 1)[0];
        newParam.values.splice(newIndex, 0, item);
        setNewParam({...newParam});
    }

    return (
        <div>
            <Typography fontWeight={500} sx={{pb: 2}}>
                {param.key}
                <IconButton onClick={onDelete}><Delete/></IconButton>
            </Typography>
            <Typography>
                <IconButton onClick={() => handleOpen()}>
                    <Edit/>
                </IconButton>
                {(param?.values || []).map((option) => `${option.label} (${option.price || 'N/A'})`).join(', ')}
            </Typography>

            <Modal open={open} onClose={() => setOpen(false)}
                   sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
            >
                <Paper sx={{p: 3}}>

                    <Grid container className={"drop-down-param-container"} flexDirection={"column"}
                          sx={{maxHeight: '70vh', minWidth: '400px', overflow: 'auto', flexWrap: 'nowrap'}}>
                        {(newParam.values || []).map((option, index) => <Grid key={index}>
                            <FormGrid size={{xs: 12}}>
                                <FormLabel htmlFor="label" sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                    Label <ArrayShifter horizontal index={index} shiftTo={orderValues}
                                                        length={(newParam.values || []).length}/>
                                    <IconButton>
                                        <DeleteOutline onClick={() => remove(index)}/>
                                    </IconButton>
                                </FormLabel>
                                <TextField
                                    id="label"
                                    placeholder={'Label'}
                                    size="small"
                                    value={option.label}
                                    onChange={(event) => onInputChange('label', index, event.target.value)}
                                />
                            </FormGrid>
                            <FormGrid size={{xs: 12}}>
                                <FormLabel htmlFor="price">
                                    Price
                                </FormLabel>
                                <TextField
                                    id="price"
                                    placeholder={'Price'}
                                    type="number"
                                    size="small"
                                    value={option.price}
                                    onChange={(event) => onInputChange('price', index, event.target.value)}
                                />
                            </FormGrid>
                            <FormControlLabel
                                sx={{px: 3, pb: 2}}
                                control={<Checkbox name="translate" value="yes"/>}
                                label="Translate"
                                onChange={(event) => onInputChange('translate', index, event.target.checked)}
                                checked={option.translate}
                            />
                        </Grid>)}
                    </Grid>
                    <IconButton onClick={addItem}>
                        <AddIcon/>
                    </IconButton>
                    <Button variant={'contained'} onClick={submit}>Submit</Button>
                </Paper>
            </Modal>
        </div>
    );
}


export default AdminDropDownParam;
